// extracted by mini-css-extract-plugin
module.exports = {"infoBlock":"InfoBlock_infoBlock__6YsSC"};